var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustriesFintech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 86,
    viewBox: "0 0 91 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#DAF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5061_3414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6063 28.3725V21.8164M30.3906 28.4876V21.8164",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3918 21.6839C31.6782 21.6839 32.7211 20.6411 32.7211 19.3547C32.7211 18.0682 31.6782 17.0254 30.3918 17.0254C29.1054 17.0254 28.0625 18.0682 28.0625 19.3547C28.0625 20.6411 29.1054 21.6839 30.3918 21.6839Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6066 21.6839C40.893 21.6839 41.9359 20.6411 41.9359 19.3547C41.9359 18.0682 40.893 17.0254 39.6066 17.0254C38.3202 17.0254 37.2773 18.0682 37.2773 19.3547C37.2773 20.6411 38.3202 21.6839 39.6066 21.6839Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 25.5254C18.2836 25.5254 19.5078 24.3012 19.5078 22.791C19.5078 21.2809 18.2836 20.0566 16.7734 20.0566C15.2633 20.0566 14.0391 21.2809 14.0391 22.791C14.0391 24.3012 15.2633 25.5254 16.7734 25.5254Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1256 32.0337V29.0177C22.1256 28.459 21.9037 27.9232 21.5087 27.5283L18.9219 24.9414",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2227 25.5254C54.7328 25.5254 55.957 24.3012 55.957 22.791C55.957 21.2809 54.7328 20.0566 53.2227 20.0566C51.7125 20.0566 50.4883 21.2809 50.4883 22.791C50.4883 24.3012 51.7125 25.5254 53.2227 25.5254Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8666 31.8951V29.0161C47.8666 28.4574 48.0885 27.9216 48.4835 27.5267L51.1488 24.8613M12.4145 55.6071H5.8125M12.5315 46.3914H5.8125",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35272 57.9379C4.63914 57.9379 5.68199 56.895 5.68199 55.6086C5.68199 54.3222 4.63914 53.2793 3.35272 53.2793C2.06629 53.2793 1.02344 54.3222 1.02344 55.6086C1.02344 56.895 2.06629 57.9379 3.35272 57.9379Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35272 48.7211C4.63914 48.7211 5.68199 47.6782 5.68199 46.3918C5.68199 45.1054 4.63914 44.0625 3.35272 44.0625C2.06629 44.0625 1.02344 45.1054 1.02344 46.3918C1.02344 47.6782 2.06629 48.7211 3.35272 48.7211Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 71.959C8.29922 71.959 9.52344 70.7348 9.52344 69.2246C9.52344 67.7145 8.29922 66.4902 6.78906 66.4902C5.27891 66.4902 4.05469 67.7145 4.05469 69.2246C4.05469 70.7348 5.27891 71.959 6.78906 71.959Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0086 63.8691H13.0177C12.4591 63.8691 11.9234 64.091 11.5283 64.486L8.82812 67.1862",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 35.5098C8.29922 35.5098 9.52344 34.2855 9.52344 32.7754C9.52344 31.2652 8.29922 30.041 6.78906 30.041C5.27891 30.041 4.05469 31.2652 4.05469 32.7754C4.05469 34.2855 5.27891 35.5098 6.78906 35.5098Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0313 38.1311H13.0153C12.4567 38.1311 11.9209 37.9092 11.5259 37.5142L8.89844 34.8867M39.6063 73.4662V80.1852M30.3906 73.6029V80.1852",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6066 84.975C40.893 84.975 41.9359 83.9321 41.9359 82.6457C41.9359 81.3593 40.893 80.3164 39.6066 80.3164C38.3202 80.3164 37.2773 81.3593 37.2773 82.6457C37.2773 83.9321 38.3202 84.975 39.6066 84.975Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3918 84.975C31.6782 84.975 32.7211 83.9321 32.7211 82.6457C32.7211 81.3593 31.6782 80.3164 30.3918 80.3164C29.1054 80.3164 28.0625 81.3593 28.0625 82.6457C28.0625 83.9321 29.1054 84.975 30.3918 84.975Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2227 81.9434C54.7328 81.9434 55.957 80.7191 55.957 79.209C55.957 77.6988 54.7328 76.4746 53.2227 76.4746C51.7125 76.4746 50.4883 77.6988 50.4883 79.209C50.4883 80.7191 51.7125 81.9434 53.2227 81.9434Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8672 70.1035V72.9827C47.8672 73.5413 48.0891 74.0771 48.4841 74.4721L51.1873 77.1753",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 81.9434C18.2836 81.9434 19.5078 80.7191 19.5078 79.209C19.5078 77.6988 18.2836 76.4746 16.7734 76.4746C15.2633 76.4746 14.0391 77.6988 14.0391 79.209C14.0391 80.7191 15.2633 81.9434 16.7734 81.9434Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1283 70.1044V72.9836C22.1283 73.5422 21.9064 74.078 21.5114 74.473L18.8984 77.0859M57.4982 46.3926H64.1824M57.4982 55.6082H64.1824",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6418 48.7211C67.9282 48.7211 68.9711 47.6782 68.9711 46.3918C68.9711 45.1054 67.9282 44.0625 66.6418 44.0625C65.3554 44.0625 64.3125 45.1054 64.3125 46.3918C64.3125 47.6782 65.3554 48.7211 66.6418 48.7211Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6418 57.9379C67.9282 57.9379 68.9711 56.895 68.9711 55.6086C68.9711 54.3222 67.9282 53.2793 66.6418 53.2793C65.3554 53.2793 64.3125 54.3222 64.3125 55.6086C64.3125 56.895 65.3554 57.9379 66.6418 57.9379Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.207 35.5098C64.7172 35.5098 65.9414 34.2855 65.9414 32.7754C65.9414 31.2652 64.7172 30.041 63.207 30.041C61.6969 30.041 60.4727 31.2652 60.4727 32.7754C60.4727 34.2855 61.6969 35.5098 63.207 35.5098Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9648 38.1303H56.9806C57.5392 38.1303 58.075 37.9084 58.47 37.5134L61.0655 34.918",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.207 71.959C64.7172 71.959 65.9414 70.7348 65.9414 69.2246C65.9414 67.7145 64.7172 66.4902 63.207 66.4902C61.6969 66.4902 60.4727 67.7145 60.4727 69.2246C60.4727 70.7348 61.6969 71.959 63.207 71.959Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0625 63.8691H56.9794C57.538 63.8691 58.0738 64.091 58.4688 64.486L61.1197 67.1369",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9976 73.8057C47.5931 73.8057 57.8038 63.5951 57.8038 50.9996C57.8038 38.404 47.5931 28.1934 34.9976 28.1934C22.4021 28.1934 12.1914 38.404 12.1914 50.9996C12.1914 63.5951 22.4021 73.8057 34.9976 73.8057Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9158 54.2834C17.7089 53.201 17.605 52.1014 17.6055 50.9994C17.6055 44.5422 21.1232 38.9066 26.3486 35.907M30.7879 34.1201C32.165 33.7786 33.5786 33.6064 34.9975 33.6074C44.6033 33.6074 52.3895 41.3936 52.3895 50.9994C52.3895 57.4594 48.869 63.0963 43.6408 66.0959M19.4621 58.8266C22.3264 64.5004 28.2066 68.3914 34.9975 68.3914C36.4467 68.3914 37.8549 68.2137 39.2002 67.8801",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9967 28.5352V32.7769M19.1113 35.1152L22.1106 38.1145M12.5312 51.0006H16.7729M19.1113 66.8861L22.1106 63.8868M34.9967 73.4661V69.2244M50.8822 66.8861L47.8829 63.8868M57.4622 51.0006H53.2205M50.8822 35.1152L47.8829 38.1145M37.2772 49.3588C36.8962 49.224 36.5307 49.1019 36.1825 48.9853C34.9658 48.5785 34.0047 48.2572 33.5922 47.7822C33.1471 47.2692 32.9888 46.6395 33.158 46.0547C33.245 45.7543 33.5005 45.2173 34.2358 44.996C35.3451 44.6617 36.1382 45.0561 36.6085 45.4456C37.4251 46.1218 38.6352 46.0084 39.3116 45.1917C39.9878 44.3753 39.8742 43.165 39.0577 42.4887C38.6641 42.1626 37.9281 41.6446 36.9163 41.3212V40.0508C36.9163 38.9906 36.0567 38.1312 34.9966 38.1312C33.9363 38.1312 33.0769 38.9907 33.0769 40.0508V41.3371C31.3209 41.8846 29.9744 43.2446 29.47 44.9875C28.9396 46.8202 29.3967 48.8058 30.6928 50.299C31.7927 51.5664 33.3337 52.0815 34.9652 52.6268C35.2936 52.7367 35.6381 52.8517 35.9977 52.9788C37.3949 53.4727 37.4362 54.5406 37.3367 55.1331C37.1691 56.1306 36.3297 57.2085 34.8834 57.2181C33.3498 57.2283 32.9115 57.1593 31.7557 56.4031C30.8687 55.8226 29.6787 56.0713 29.0981 56.9584C28.5178 57.8457 28.7663 59.0355 29.6536 59.616C30.9547 60.4671 31.9258 60.8321 33.0769 60.9752V61.9506C33.0769 63.0108 33.9363 63.8703 34.9966 63.8703C36.0569 63.8703 36.9163 63.0107 36.9163 61.9506V60.7279C39.2702 59.9371 40.7748 57.84 41.1228 55.7695C41.6026 52.9177 40.057 50.3414 37.2772 49.3588Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5061_3414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustriesFintech);
export default __webpack_public_path__ + "static/media/industries-fintech.702a522d280cc27f2defbbc293e1ca0c.svg";
export { ForwardRef as ReactComponent };